import React from "react";

// Recreated "Rename STUDIO AI" wordmark (crisp, scalable, dark-friendly).
export default function BrandLogo({ className = "" }) {
  return (
    <div className={`inline-flex flex-col leading-none select-none ${className}`} data-testid="brand-logo">
      <div className="flex items-end gap-1.5">
        <span className="font-display font-black text-2xl tracking-tight bg-gradient-to-r from-white via-[#bfdbfe] to-[#38bdf8] bg-clip-text text-transparent">
          Rename
        </span>
        <span className="text-[9px] font-black text-white bg-gradient-to-br from-[#3b82f6] to-[#7c3aed] rounded-md px-1.5 py-0.5 mb-1 shadow-[0_0_12px_rgba(59,130,246,0.6)]">
          AI
        </span>
      </div>
      <div className="flex items-center gap-1.5 mt-1 w-full">
        <span className="h-px w-3 bg-white/40" />
        <span className="text-[8px] tracking-[0.42em] text-neutral-300 font-semibold">STUDIO</span>
        <span className="h-px flex-1 bg-white/25" />
      </div>
    </div>
  );
}
